import { DictionaryBase } from './types';

const SysOperationType = new DictionaryBase('操作日志操作类型', [
  {
    id: 0,
    name: '登录',
    symbol: 'LOGIN',
  },
  {
    id: 1,
    name: '手机登录',
    symbol: 'MOBILE_LOGIN',
  },
  {
    id: 5,
    name: '登出',
    symbol: 'LOGOUT',
  },
  {
    id: 6,
    name: '移动端登出',
    symbol: 'MOBILE_LOGOUT',
  },
  {
    id: 7,
    name: '重置密码',
    symbol: 'RESET_PASSWORD',
  },
  {
    id: 10,
    name: '新增',
    symbol: 'ADD',
  },
  {
    id: 15,
    name: '修改',
    symbol: 'UPDATE',
  },
  {
    id: 20,
    name: '删除',
    symbol: 'DELETE',
  },
  {
    id: 21,
    name: '批量删除',
    symbol: 'BATCH_DELETE',
  },
  {
    id: 25,
    name: '新增多对多关联',
    symbol: 'ADD_M2M',
  },
  {
    id: 30,
    name: '移除多对多关联',
    symbol: 'DELETE_M2M',
  },
  {
    id: 21,
    name: '批量移除多对多关联',
    symbol: 'DELETE_M2M_BATCH',
  },
  {
    id: 35,
    name: '查询',
    symbol: 'LIST',
  },
  {
    id: 40,
    name: '分组查询',
    symbol: 'LIST_WITH_GROUP',
  },
  {
    id: 45,
    name: '导出',
    symbol: 'EXPORT',
  },
  {
    id: 46,
    name: '导入',
    symbol: 'IMPORT',
  },
  {
    id: 50,
    name: '上传',
    symbol: 'UPLOAD',
  },
  {
    id: 55,
    name: '下载',
    symbol: 'DOWNLOAD',
  },
  {
    id: 60,
    name: '重置缓存',
    symbol: 'RELOAD_CACHE',
  },
  {
    id: 65,
    name: '发布',
    symbol: 'PUBLISH',
  },
  {
    id: 70,
    name: '取消发布',
    symbol: 'UNPUBLISH',
  },
  {
    id: 75,
    name: '流程挂起',
    symbol: 'SUSPEND',
  },
  {
    id: 80,
    name: '流程恢复',
    symbol: 'RESUME',
  },
  {
    id: 100,
    name: '启动流程',
    symbol: 'START_FLOW',
  },
  {
    id: 105,
    name: '终止流程',
    symbol: 'STOP_FLOW',
  },
  {
    id: 110,
    name: '删除流程',
    symbol: 'DELETE_FLOW',
  },
  {
    id: 115,
    name: '撤销流程',
    symbol: 'CANCEL_FLOW',
  },
  {
    id: 120,
    name: '提交流程任务',
    symbol: 'SUBMIT_TASK',
  },
  {
    id: 125,
    name: '催办流程',
    symbol: 'REMIND_TASK',
  },
  {
    id: 126,
    name: '流程干预',
    symbol: 'INTERVENE_FLOW',
  },
  {
    id: 127,
    name: '流程数据补偿',
    symbol: 'FIX_FLOW_BUSINESS_DATA',
  },
  {
    id: 128,
    name: '流程复活',
    symbol: 'REVIVE_FLOW',
  },
  {
    id: 129,
    name: '补偿流程任务',
    symbol: 'FIX_AUTO_FLOW_DATA',
  },
]);

const SysPermModuleType = new DictionaryBase('权限分组类型', [
  {
    id: 0,
    name: '分组模块',
    symbol: 'GROUP',
  },
  {
    id: 1,
    name: '接口模块',
    symbol: 'CONTROLLER',
  },
]);

const SysPermCodeType = new DictionaryBase('权限字类型', [
  {
    id: 0,
    name: '表单',
    symbol: 'FORM',
  },
  {
    id: 1,
    name: '片段',
    symbol: 'FRAGMENT',
  },
  {
    id: 2,
    name: '操作',
    symbol: 'OPERATION',
  },
]);

/**
 * 菜单类型
 *
 * DIRECTORY(0: 目录)
 * MENU(1: 表单)
 * FRAGMENT(2: 片段)
 * BUTTON(3: 按钮)
 */
const SysMenuType = new DictionaryBase('菜单类型', [
  {
    id: 0,
    name: '目录',
    symbol: 'DIRECTORY',
  },
  {
    id: 1,
    name: '菜单',
    symbol: 'MENU',
  },
  {
    id: 2,
    name: '片段',
    symbol: 'FRAGMENT',
  },
  {
    id: 3,
    name: '按钮',
    symbol: 'BUTTON',
  },
]);

const MobileEntryType = new DictionaryBase('移动端首页配置项类型', [
  {
    id: 0,
    name: '轮播图',
    symbol: 'BANNER',
  },
  {
    id: 1,
    name: '九宫格',
    symbol: 'SUDOKU',
  },
  {
    id: 2,
    name: '分组',
    symbol: 'GROUP',
  },
]);

/**
 * 菜单绑定类型
 *
 * ROUTER(0: 路由菜单)
 * ONLINE_FORM(1: 在线表单)
 * WORK_ORDER(2: 工单列表)
 * REPORT(3: 报表页面)
 * THRID_URL(4: 外部链接)
 */
const SysMenuBindType = new DictionaryBase('菜单绑定类型', [
  {
    id: 0,
    name: '路由菜单',
    symbol: 'ROUTER',
  },
  {
    id: 5,
    name: '路由工单',
    symbol: 'ROUTER_WORK_ORDER',
  },
  {
    id: 1,
    name: '在线表单',
    symbol: 'ONLINE_FORM',
  },
  {
    id: 2,
    name: '工单列表',
    symbol: 'WORK_ORDER',
  },
  {
    id: 3,
    name: '报表页面',
    symbol: 'REPORT',
  },
  {
    id: 4,
    name: '外部链接',
    symbol: 'THRID_URL',
  },
]);

const SysDataPermType = new DictionaryBase('数据权限类型', [
  {
    id: 0,
    name: '查看全部',
    symbol: 'ALL',
  },
  {
    id: 1,
    name: '仅看自己',
    symbol: 'ONLY_USER',
  },
  {
    id: 2,
    name: '仅看所在部门',
    symbol: 'ONLY_DEPT',
  },
  {
    id: 3,
    name: '仅看所在部门及子部门',
    symbol: 'ONLY_DEPT_AND_CHILD',
  },
  {
    id: 4,
    name: '自选部门及子部门',
    symbol: 'CUSTOM_DEPT_AND_CHILD',
  },
  {
    id: 5,
    name: '仅自选部门',
    symbol: 'CUSTOM_DEPT',
  },
  {
    id: 6,
    name: '本部门用户',
    symbol: 'DEPT_USER',
  },
  {
    id: 7,
    name: '本部门及子部门用户',
    symbol: 'DEPT_AND_CHILD_USER',
  },
  {
    id: 20,
    name: '自定义',
    symbol: 'SQL',
  },
]);

const ScatterSymbolType = new DictionaryBase('纵轴位置', [
  {
    id: 0,
    name: '固定大小',
    symbol: 'FIXED',
  },
  {
    id: 1,
    name: '值大小',
    symbol: 'VALUE',
  },
]);

const SysCustomWidgetType = new DictionaryBase('组件类型', [
  {
    id: 0,
    name: '文本显示',
    symbol: 'Label',
  },
  {
    id: 1,
    name: '文本输入框',
    symbol: 'Input',
  },
  {
    id: 3,
    name: '数字输入框',
    symbol: 'NumberInput',
  },
  {
    id: 4,
    name: '数字范围输入框',
    symbol: 'NumberRange',
  },
  {
    id: 5,
    name: '开关组件',
    symbol: 'Switch',
  },
  {
    id: 6,
    name: '滑块组件',
    symbol: 'Slider',
  },
  {
    id: 7,
    name: '单选组件',
    symbol: 'Radio',
  },
  {
    id: 8,
    name: '复选框',
    symbol: 'CheckBox',
  },
  {
    id: 10,
    name: '下拉选择框',
    symbol: 'Select',
  },
  {
    id: 12,
    name: '级联选择框',
    symbol: 'Cascader',
  },
  {
    id: 13,
    name: '树形选择组件',
    symbol: 'Tree',
  },
  {
    id: 14,
    name: '评分组件',
    symbol: 'Rate',
  },
  {
    id: 15,
    name: '进步器',
    symbol: 'Stepper',
  },
  {
    id: 16,
    name: '日历组件',
    symbol: 'Calendar',
  },
  {
    id: 20,
    name: '日期选择框',
    symbol: 'Date',
  },
  {
    id: 21,
    name: '日期范围',
    symbol: 'DateRange',
  },
  {
    id: 30,
    name: '颜色选择框',
    symbol: 'ColorPicker',
  },
  {
    id: 31,
    name: '上传组件',
    symbol: 'Upload',
  },
  {
    id: 32,
    name: '富文本编辑',
    symbol: 'RichEditor',
  },
  {
    id: 33,
    name: '单选按钮组',
    symbol: 'RadioButtonGroup',
  },
  {
    id: 40,
    name: '分割线',
    symbol: 'Divider',
  },
  {
    id: 41,
    name: '文本',
    symbol: 'Text',
  },
  {
    id: 42,
    name: '图片',
    symbol: 'Image',
  },
  {
    id: 44,
    name: '标题栏',
    symbol: 'Title'
  },
  {
    id: 45,
    name: '签名组件',
    symbol: 'Signature'
  },
  {
    id: 43,
    name: '超链接',
    symbol: 'Link',
  },
  {
    id: 100,
    name: '表格组件',
    symbol: 'Table',
  },
  {
    id: 101,
    name: '透视表',
    symbol: 'PivotTable',
  },
  {
    id: 102,
    name: '数据列表',
    symbol: 'List',
  },
  {
    id: 103,
    name: '查询列表',
    symbol: 'QueryList',
  },
  {
    id: 104,
    name: '工单列表',
    symbol: 'WorkOrderList',
  },
  {
    id: 200,
    name: '折线图',
    symbol: 'LineChart',
  },
  {
    id: 201,
    name: '柱状图',
    symbol: 'BarChart',
  },
  {
    id: 202,
    name: '饼图',
    symbol: 'PieChart',
  },
  {
    id: 203,
    name: '散点图',
    symbol: 'ScatterChart',
  },
  {
    id: 204,
    name: '普通表格',
    symbol: 'DataViewTable',
  },
  {
    id: 205,
    name: '轮播图',
    symbol: 'Carousel',
  },
  {
    id: 206,
    name: '富文本',
    symbol: 'RichText',
  },
  {
    id: 207,
    name: '仪表盘',
    symbol: 'GaugeChart',
  },
  {
    id: 208,
    name: '漏斗图',
    symbol: 'FunnelChart',
  },
  {
    id: 209,
    name: '雷达图',
    symbol: 'RadarChart',
  },
  {
    id: 210,
    name: '普通进度条',
    symbol: 'ProgressBar',
  },
  {
    id: 211,
    name: '环形进度条',
    symbol: 'ProgressCircle',
  },
  {
    id: 212,
    name: '通用卡片',
    symbol: 'DataCard',
  },
  {
    id: 213,
    name: '通用列表',
    symbol: 'CommonList',
  },
  {
    id: 214,
    name: '进度条卡片',
    symbol: 'DataProgressCard',
  },
  {
    id: 300,
    name: '基础块',
    symbol: 'Block',
  },
  {
    id: 301,
    name: '卡片组件',
    symbol: 'Card',
  },
  {
    id: 302,
    name: 'Tabs 组件',
    symbol: 'Tabs',
  },
  {
    id: 303,
    name: '图片卡片',
    symbol: 'ImageCard',
  },
  {
    id: 304,
    name: '分组容器',
    symbol: 'CellGroup',
  },
  {
    id: 400,
    name: '用户选择',
    symbol: 'UserSelect',
  },
  {
    id: 401,
    name: '部门选择',
    symbol: 'DeptSelect',
  },
  {
    id: 402,
    name: '关联选择',
    symbol: 'DataSelect',
  },
  {
    id: 403,
    name: '表格容器',
    symbol: 'TableContainer',
  },
  {
    id: 404,
    name: '字典选择',
    symbol: 'DictSelect',
  },
  {
    id: 405,
    name: '流程统计',
    symbol: 'FlowCountStatusCard',
  },
  {
    id: 406,
    name: '视频组件',
    symbol: 'Video',
  },
  {
    id: 407,
    name: '地图组件',
    symbol: 'MAP',
  },
  {
    id: 408,
    name: '二维码',
    symbol: 'QRCODE',
  },
  {
    id: 409,
    name: '条形码',
    symbol: 'BARCODE',
  },
  {
    id: 500,
    name: '单选过滤',
    symbol: 'MobileRadioFilter',
  },
  {
    id: 501,
    name: '多选过滤',
    symbol: 'MobileCheckBoxFilter',
  },
  {
    id: 502,
    name: '文本过滤',
    symbol: 'MobileInputFilter',
  },
  {
    id: 503,
    name: '开关过滤',
    symbol: 'MobileSwitchFilter',
  },
  {
    id: 504,
    name: '日期过滤',
    symbol: 'MobileDateRangeFilter',
  },
  {
    id: 505,
    name: '数字范围过滤',
    symbol: 'MobileNumberRangeFilter',
  },
  // 行内编辑组件
  {
    id: 600,
    name: '输入框',
    symbol: 'INLINE_INPUT',
  },
  {
    id: 601,
    name: '数字输入框',
    symbol: 'INLINE_NUMBER_INPUT',
  },
  {
    id: 602,
    name: '日期输入框',
    symbol: 'INLINE_DATE',
  },
  {
    id: 603,
    name: '下拉选择框',
    symbol: 'INLINE_SELECT',
  },
  {
    id: 604,
    name: '级联选择组件',
    symbol: 'INLINE_CASCADE',
  },
  {
    id: 605,
    name: '开关组件',
    symbol: 'INLINE_SWITCH',
  },
  {
    id: 606,
    name: '上传组件',
    symbol: 'INLINE_UPLOAD',
  },
]);

const OnlineFormEventType = new DictionaryBase('在线表单事件类型', [
  {
    id: 'change',
    name: '数据改变',
    symbol: 'CHANGE',
  },
  {
    id: 'blur',
    name: '失去焦点',
    symbol: 'BLUR',
  },
  {
    id: 'focus',
    name: '获取焦点',
    symbol: 'FOCUS',
  },
  {
    id: 'disable',
    name: '是否禁用',
    symbol: 'DISABLE',
  },
  {
    id: 'visible',
    name: '是否可见',
    symbol: 'VISIBLE',
  },
  {
    id: 'dropdownChange',
    name: '下拉数据改变',
    symbol: 'DROPDOWN_CHANGE',
  },
  {
    id: 'linkHerf',
    name: '链接地址',
    symbol: 'LINK_HERF',
  },
  {
    id: 'disabledDate',
    name: '日期是否可用',
    symbol: 'DISABLED_DATE',
  },
  {
    id: 'afterLoadTableData',
    name: '表格加载数据后',
    symbol: 'AFTER_LOAD_TABLE_DATA',
  },
  {
    id: 'beforeLoadTableData',
    name: '表格加载数据前',
    symbol: 'BEFORE_LOAD_TABLE_DATA',
  },
  {
    id: 'afterLoadFormData',
    name: '页面加载数据后',
    symbol: 'AFTER_LOAD_FORM_DATA',
  },
  {
    id: 'beforeLoadFormData',
    name: '页面加载数据前',
    symbol: 'BEFORE_LOAD_FORM_DATA',
  },
  {
    id: 'beforeCommitFormData',
    name: '页面数据提交前',
    symbol: 'BEFORE_COMMIT_FORM_DATA',
  },
  {
    id: 'formCreated',
    name: '页面创建完毕',
    symbol: 'AFTER_CREATE_FORM',
  },
  {
    id: 'tableOperationVisible',
    name: '操作是否可见',
    symbol: 'OPERATION_VISIBLE',
  },
  {
    id: 'tableOperationDisbled',
    name: '操作是否禁用',
    symbol: 'OPERATION_DISABLED',
  },
  {
    id: 'tableOperationClick',
    name: '操作点击事件',
    symbol: 'OPERATION_CLICK'
  },
  {
    id: 'tableCellClick',
    name: '单元格点击事件',
    symbol: 'CELL_CLICK'
  },
  {
    id: 'tableCellRender',
    name: '单元格渲染事件',
    symbol: 'CELL_RENDER',
  },
  {
    id: 'dialogOpen',
    name: '对话框过滤事件',
    symbol: 'DIALOG_OPEN',
  },
  {
    id: 'dialogSubmit',
    name: '对话框回调事件',
    symbol: 'DIALOG_SUBMIT',
  },
  {
    id: 'tableInlineValueChange',
    name: '数据改变',
    symbol: 'INLINE_VALUE_CHANGE',
  },
  {
    id: 'tableInlineDisabled',
    name: '组件是否禁用',
    symbol: 'INLINE_DISABLED',
  },
  {
    id: 'tableColumnTagType',
    name: '单元格标签类型',
    symbol: 'CELL_TAG_TYPE',
  },
  {
    id: 'footerData',
    name: '表尾数据',
    symbol: 'FOOTER_DATA',
  },
  {
    id: 'linkClick',
    name: '链接点击事件',
    symbol: 'LINK_CLICK',
  },
  {
    id: 'reportCellClick',
    name: '单元格点击事件',
    symbol: 'REPORT_CELL_CLICK',
  },
  {
    id: 'serieClick',
    name: '图表点击事件',
    symbol: 'SERIE_CLICK',
  },
]);

const SysOnlineRelationType = new DictionaryBase('关联类型', [
  {
    id: 0,
    name: '一对一关联',
    symbol: 'ONE_TO_ONE'
  },
  {
    id: 1,
    name: '一对多关联',
    symbol: 'ONE_TO_MANY'
  }
]);

const SysAutoCodeType = new DictionaryBase('自动编码类型', [
  {
    id: 'YEAR',
    name: '精确到年',
    symbol: 'YEAR',
  },
  {
    id: 'MONTH',
    name: '精确到月',
    symbol: 'MONTH',
  },
  {
    id: 'DAYS',
    name: '精确到日',
    symbol: 'DAYS',
  },
  {
    id: 'HOURS',
    name: '精确到时',
    symbol: 'HOURS',
  },
  {
    id: 'MINUTES',
    name: '精确到分',
    symbol: 'MINUTES',
  },
  {
    id: 'SECONDS',
    name: '精确到秒',
    symbol: 'SECONDS',
  },
]);

/**
 * 表单类型
 *
 * QUERY(1: 查询表单)
 * ADVANCE_QUERY(2: 左树右表查询)
 * ONE_TO_ONE_QUERY(3: 一对一查询)
 * FORM(5: 编辑表单)
 * FLOW(10: 流程表单)
 * WORK_ORDER(11: 工单列表)
 * REPORT(50: 报表页面)
 */
const SysOnlineFormType = new DictionaryBase('表单类型', [
  {
    id: 1,
    name: '查询表单',
    symbol: 'QUERY',
  },
  {
    id: 2,
    name: '左树右表',
    symbol: 'ADVANCE_QUERY',
  },
  {
    id: 3,
    name: '一对一查询',
    symbol: 'ONE_TO_ONE_QUERY',
  },
  {
    id: 4,
    name: '分组查询',
    symbol: 'GROUP_QUERY',
  },
  {
    id: 5,
    name: '编辑表单',
    symbol: 'FORM',
  },
  {
    id: 10,
    name: '流程表单',
    symbol: 'FLOW',
  },
  {
    id: 11,
    name: '工单列表',
    symbol: 'WORK_ORDER',
  },
  {
    id: 50,
    name: '报表页面',
    symbol: 'REPORT',
  },
]);

const SysCustomWidgetOperationType = new DictionaryBase('操作类型', [
  {
    id: 0,
    name: '新建',
    symbol: 'ADD',
  },
  {
    id: 1,
    name: '编辑',
    symbol: 'EDIT',
  },
  {
    id: 2,
    name: '删除',
    symbol: 'DELETE',
  },
  {
    id: 3,
    name: '导出',
    symbol: 'EXPORT',
  },
  {
    id: 4,
    name: '导入',
    symbol: 'IMPORT',
  },
  {
    id: 5,
    name: '启动流程',
    symbol: 'START_FLOW',
  },
  {
    id: 10,
    name: '批量删除',
    symbol: 'BATCH_DELETE',
  },
  {
    id: 20,
    name: '表单操作',
    symbol: 'FORM',
  },
  {
    id: 21,
    name: '打印操作',
    symbol: 'PRINT',
  },
  {
    id: 22,
    name: '复制',
    symbol: 'COPY',
  },
  {
    id: 23,
    name: '更新数据',
    symbol: 'UPDATE',
  },
  {
    id: 24,
    name: '更新数据（弹窗）',
    symbol: 'UPDATE_DIALOG',
  },
  {
    id: 30,
    name: '保存',
    symbol: 'SAVE',
  },
  {
    id: 31,
    name: '取消',
    symbol: 'CANCEL',
  },
  {
    id: 40,
    name: '行内添加',
    symbol: 'INLINE_ADD',
  },
  {
    id: 41,
    name: '行内编辑',
    symbol: 'INLINE_EDIT',
  },
  {
    id: 50,
    name: '脚本操作',
    symbol: 'SCRIPT',
  },
  {
    id: 51,
    name: '下钻事件',
    symbol: 'DRILL',
  },
  {
    id: 52,
    name: '路由跳转',
    symbol: 'ROUTE',
  },
  {
    id: 53,
    name: '弹窗选择',
    symbol: 'SELECT_DIALOG',
  },
]);

const OnlineSystemVariableType = new DictionaryBase('系统变量类型', [
  {
    id: 0,
    name: '登录用户',
    symbol: 'CURRENT_USER',
  },
  {
    id: 1,
    name: '所属部门',
    symbol: 'CURRENT_DEPT',
  },
  {
    id: 10,
    name: '当前日期',
    symbol: 'CURRENT_DATE',
  },
  {
    id: 11,
    name: '当前时间',
    symbol: 'CURRENT_TIME',
  },
  {
    id: 20,
    name: '流程发起人',
    symbol: 'FLOW_CREATE_USER',
  },
]);

const SysCustomWidgetBindDataType = new DictionaryBase('组件绑定数据类型', [
  {
    id: 0,
    name: '字段',
    symbol: 'Column',
  },
  {
    id: 5,
    name: '系统变量',
    symbol: 'SYSTEM_VARIABLE',
  },
  {
    id: 10,
    name: '自定义字段',
    symbol: 'Custom',
  },
  {
    id: 20,
    name: '固定值',
    symbol: 'Fixed',
  },
]);

const SysMaskFieldType = new DictionaryBase('脱敏类型', [
  {
    id: 'CUSTOM',
    name: '自定义',
    symbol: 'CUSTOM',
  },
  {
    id: 'NAME',
    name: '姓名',
    symbol: 'NAME',
  },
  {
    id: 'MOBILE_PHONE',
    name: '移动电话',
    symbol: 'MOBILE_PHONE',
  },
  {
    id: 'FIXED_PHONE',
    name: '座机电话',
    symbol: 'FIXED_PHONE',
  },
  {
    id: 'ID_CARD',
    name: '身份证',
    symbol: 'ID_CARD',
  },
  {
    id: 'BANK_CARD',
    name: '银行卡号',
    symbol: 'BANK_CARD',
  },
  {
    id: 'CAR_LICENSE',
    name: '汽车牌照号',
    symbol: 'CAR_LICENSE',
  },
  {
    id: 'EMAIL',
    name: '电子邮箱地址',
    symbol: 'EMAIL',
  },
  {
    id: 'PASSWORD',
    name: '密码',
    symbol: 'PASSWORD'
  },
]);

const EnumFileType = new DictionaryBase('文件类型', [
  {
    id: 1,
    name: '图片',
    symbol: 'IMAGE',
  },
  {
    id: 2,
    name: '音频',
    symbol: 'AUDIO',
  },
  {
    id: 3,
    name: '视频',
    symbol: 'VIDEO',
  },
  {
    id: 4,
    name: 'PDF',
    symbol: 'PDF',
  },
  {
    id: 5,
    name: 'Word',
    symbol: 'WORD',
  },
  {
    id: 6,
    name: 'Excel',
    symbol: 'EXCEL',
  },
  /*
  {
    id: 7,
    name: 'PPT',
    symbol: 'PPT',
  },
  {
    id: 8,
    name: '文本',
    symbol: 'TEXT',
  },
  {
    id: 9,
    name: '压缩包',
    symbol: 'ZIP',
  },
  {
    id: 10,
    name: 'Markdown',
    symbol: 'MARKDOWN',
  },
  {
    id: 11,
    name: 'HTML',
    symbol: 'HTML',
  },
  */
  {
    id: 999,
    name: '其他文件',
    symbol: 'FILE',
  },
]);

const SysOnlineDictType = new DictionaryBase('字典类型', [
  {
    id: 1,
    name: '数据表字典',
    symbol: 'TABLE',
  },
  {
    id: 5,
    name: 'URL字典',
    symbol: 'URL',
  },
  /*
  {
    id: 10,
    name: '静态字典',
    symbol: 'STATIC',
  },
  */
  {
    id: 20,
    name: '编码字典',
    symbol: 'CODE',
  },
  {
    id: 15,
    name: '自定义字典',
    symbol: 'CUSTOM',
  },
]);

const DirectionType = new DictionaryBase('方向', [
  {
    id: 0,
    name: '横轴',
    symbol: 'HORIZONTAL',
  },
  {
    id: 1,
    name: '纵轴',
    symbol: 'VERTICAL',
  },
]);

const DblinkType = new DictionaryBase('数据库连接类型', [
  {
    id: 0,
    name: 'MySQL',
    symbol: 'MYSQL',
  },
  {
    id: 1,
    name: 'PostgreSQL',
    symbol: 'POSTGRESQL',
  },
  {
    id: 2,
    name: 'Oracle',
    symbol: 'ORACLE',
  },
  {
    id: 6,
    name: 'SQL Server',
    symbol: 'SQL_SERVER'
  },
  {
    id: 3,
    name: '达梦数据库',
    symbol: 'DM_DB',
  },
  {
    id: 4,
    name: '人大金仓',
    symbol: 'KINGBASE',
  },
  {
    id: 5,
    name: '华为高斯',
    symbol: 'OPENGAUSS',
  },
  {
    id: 10,
    name: 'ClickHouse',
    symbol: 'CLICK_HOUSE',
  },
  {
    id: 11,
    name: 'Doris',
    symbol: 'DORIS',
  },
]);

const CriteriaFilterType = new DictionaryBase('条件过滤类型', [
  {
    id: 0,
    name: '等于',
    symbol: 'EQ',
  },
  {
    id: 1,
    name: '不等于',
    symbol: 'NOT_EQ',
  },
  {
    id: 2,
    name: '大于等于',
    symbol: 'GE',
  },
  {
    id: 3,
    name: '大于',
    symbol: 'GT',
  },
  {
    id: 4,
    name: '小于等于',
    symbol: 'LE',
  },
  {
    id: 5,
    name: '小于',
    symbol: 'LT',
  },
  {
    id: 6,
    name: 'LIKE',
    symbol: 'LIKE',
  },
  {
    id: 7,
    name: 'IN',
    symbol: 'IN',
  },
  {
    id: 8,
    name: 'NOT IN',
    symbol: 'NOT_IN',
  },
  {
    id: 9,
    name: 'BETWEEN',
    symbol: 'BETWEEN',
  },
  {
    id: 100,
    name: '不为空',
    symbol: 'NOT_NULL',
  },
  {
    id: 101,
    name: '为空',
    symbol: 'IS_NULL',
  },
]);

const FormulaItemKind = new DictionaryBase('公式项类型', [
  {
    id: 'varable',
    name: '变量',
    symbol: 'VARABLE',
  },
  {
    id: 'number',
    name: '数字',
    symbol: 'NUMBER',
  },
  {
    id: 'string',
    name: '字符串',
    symbol: 'STRING',
  },
  {
    id: 'operator',
    name: '操作符',
    symbol: 'OPERATOR',
  },
  {
    id: 'function',
    name: '函数',
    symbol: 'FUNCTION',
  },
]);

const SysOnlineRuleType = new DictionaryBase('验证规则类型', [
  {
    id: 1,
    name: '只允许整数',
    symbol: 'INTEGER_ONLY',
  },
  {
    id: 2,
    name: '只允许数字',
    symbol: 'DIGITAL_ONLY',
  },
  {
    id: 3,
    name: '只允许英文字符',
    symbol: 'LETTER_ONLY',
  },
  {
    id: 4,
    name: '范围验证',
    symbol: 'RANGE',
  },
  {
    id: 5,
    name: '邮箱格式验证',
    symbol: 'EMAIL',
  },
  {
    id: 6,
    name: '手机格式验证',
    symbol: 'MOBILE',
  },
  {
    id: 100,
    name: '自定义验证',
    symbol: 'CUSTOM',
  },
]);

const LogicOperatorType = new DictionaryBase('逻辑运算符', [
  {
    id: 'AND',
    name: '且',
    symbol: 'AND',
  },
  {
    id: 'OR',
    name: '或',
    symbol: 'OR',
  },
]);

const CustomQueryFilterValueType = new DictionaryBase('自定义查询过滤值类型', [
  {
    id: 0,
    name: '固定值',
    symbol: 'FIXED',
  },
  {
    id: 1,
    name: '字典值',
    symbol: 'DICT',
  },
]);

const SysUserStatus = new DictionaryBase('用户状态', [
  {
    id: 0,
    name: '正常状态',
    symbol: 'NORMAL'
  },
  {
    id: 1,
    name: '锁定状态',
    symbol: 'LOCKED'
  }
]);

const SysUserType = new DictionaryBase('用户类型', [
  {
    id: 0,
    name: '管理员',
    symbol: 'ADMIN'
  },
  {
    id: 1,
    name: '系统操作员',
    symbol: 'SYSTEM'
  },
  {
    id: 2,
    name: '普通操作员',
    symbol: 'OPERATOR'
  }
]);

const ZODIACSIGN = new DictionaryBase('属相', [
  {
    id: '鼠',
    name: '鼠',
    symbol: 'RAT'
  },
  {
    id: '牛',
    name: '牛',
    symbol: 'OX'
  },
  {
    id: '虎',
    name: '虎',
    symbol: 'TIGER'
  },
  {
    id: '兔',
    name: '兔',
    symbol: 'RABBIT'
  },
  {
    id: '龙',
    name: '龙',
    symbol: 'DRAGON'
  },
  {
    id: '蛇',
    name: '蛇',
    symbol: 'SNAKE'
  },
  {
    id: '马',
    name: '马',
    symbol: 'HORSE'
  },
  {
    id: '羊',
    name: '羊',
    symbol: 'GOAT'
  },
  {
    id: '猴',
    name: '猴',
    symbol: 'MONKEY'
  },
  {
    id: '鸡',
    name: '鸡',
    symbol: 'ROOSTER'
  },
  {
    id: '狗',
    name: '狗',
    symbol: 'DOG'
  },
  {
    id: '猪',
    name: '猪',
    symbol: 'PIG'
  }
]);

const STARSIGN = new DictionaryBase('星座', [
  {
    id: '摩羯座',
    name: '摩羯座',
    symbol: 'CAPRICORN'
  },
  {
    id: '水瓶座',
    name: '水瓶座',
    symbol: 'AQUARIUS'
  },
  {
    id: '双鱼座',
    name: '双鱼座',
    symbol: 'PISCES'
  },
  {
    id: '白羊座',
    name: '白羊座',
    symbol: 'ARIES'
  },
  {
    id: '金牛座',
    name: '金牛座',
    symbol: 'TAURUS'
  },
  {
    id: '双子座',
    name: '双子座',
    symbol: 'GEMINI'
  },
  {
    id: '巨蟹座',
    name: '巨蟹座',
    symbol: 'CANCER'
  },
  {
    id: '狮子座',
    name: '狮子座',
    symbol: 'LEO'
  },
  {
    id: '处女座',
    name: '处女座',
    symbol: 'VIRGO'
  },
  {
    id: '天秤座',
    name: '天秤座',
    symbol: 'LIBRA'
  },
  {
    id: '天蝎座',
    name: '天蝎座',
    symbol: 'SCORPIO'
  },
  {
    id: '射手座',
    name: '射手座',
    symbol: 'SAGITTARIUS'
  }
]);

const GENDER = new DictionaryBase('性别', [
  {
    id: '男',
    name: '男',
    symbol: 'MALE'
  },
  {
    id: '女',
    name: '女',
    symbol: 'FEMALE'
  },
  {
    id: '其他',
    name: '其他',
    symbol: 'OTHER'
  }
]);

const PsscCertified = new DictionaryBase('PSSC认证情况', [
  {
    id: '已认证',
    name: '是',
    symbol: 'TRUE'
  },
  {
    id: '未认证',
    name: '否',
    symbol: 'FALSE'
  }
]);

const ExpertTimeCategory = new DictionaryBase('专家收费时间维度', [
  {
    id: '半天',
    name: '半天',
    symbol: 'HALF_A_DAY'
  },
  {
    id: '一天',
    name: '一天',
    symbol: 'DAY'
  }
]);

const PlatformType = new DictionaryBase('平台类型', [
  {
    id: 'DH网蓝智库信息管理系统',
    name: 'DH网蓝智库信息管理系统',
    symbol: 'DHWLZK'
  },
  {
    id: 'DH组织架构信息管理系统',
    name: 'DH组织架构信息管理系统',
    symbol: 'DHZZJG'
  },
  {
    id: 'BW直播信息管理系统',
    name: 'BW直播信息管理系统',
    symbol: 'BWZBXX'
  },
  {
    id: 'DH生态活动信息管理系统',
    name: 'DH生态活动信息管理系统',
    symbol: 'DHSTHD'
  },
  {
    id: '未来栋梁系统',
    name: '未来栋梁系统',
    symbol: 'WLDL'
  }
]);

const DeptCategoryType = new DictionaryBase('部门标签类型', [
  {
    id: '部门属性',
    name: '部门属性',
    symbol: 'ATTRIBUTE'
  },
  {
    id: '部门等级',
    name: '部门等级',
    symbol: 'LEVEL'
  }
]);

const LiveControlType = new DictionaryBase('直播执行这类型', [
  {
    id: '直播总控',
    name: '直播总控',
    symbol: 'GENERAL_CONTROL'
  },
  {
    id: '技术专员',
    name: '技术专员',
    symbol: 'TECHNICAL_ATTACHE'
  }
]);

const ActivitiesCostType = new DictionaryBase('活动费用类型', [
  {
    id: '免费',
    name: '免费',
    symbol: 'FREE'
  },
  {
    id: '收费',
    name: '收费',
    symbol: 'CHARGE'
  }
]);

const WissoRoomStatus = new DictionaryBase('WISSO直播间状态', [
  {
    id: 'OPEN',
    name: '开启',
    symbol: 'OPEN'
  },
  {
    id: 'CLOSE',
    name: '关闭',
    symbol: 'CLOSE'
  },
  {
    id: 'DELETE',
    name: '删除',
    symbol: 'DELETE'
  }
]);

const MaritalStatus = new DictionaryBase('婚姻情况', [
  {
    id: '未婚',
    name: '未婚',
    symbol: 'SINGLE'
  },
  {
    id: '已婚',
    name: '已婚',
    symbol: 'MARRIED'
  },
  {
    id: '离异',
    name: '离异',
    symbol: 'DIVORCED'
  }
]);

const ActivityDic = new DictionaryBase('活动收费类型', [
  {
    id: '已收费',
    name: '已收费',
    symbol: 'CHARGED'
  },
  {
    id: '未收费',
    name: '未收费',
    symbol: 'UN_CHARGED'
  }
]);

const WORKSCORE = new DictionaryBase('未来栋梁作品评分', [
  {
    id: '超级棒',
    name: '超级棒',
    symbol: 'SUPER'
  },
  {
    id: '很棒',
    name: '很棒',
    symbol: 'GREAT'
  },
  {
    id: '优秀',
    name: '优秀',
    symbol: 'EXCELLENT'
  },
  {
    id: '良好',
    name: '良好',
    symbol: 'GOOD'
  },
  {
    id: '一般',
    name: '一般',
    symbol: 'FAIR'
  },
  {
    id: '差',
    name: '差',
    symbol: 'POOR'
  }
]);

const ApplyStatus = new DictionaryBase('申请状态', [
  {
    id: '待审核',
    name: '待审核',
    symbol: 'WILL'
  },
  {
    id: '已通过',
    name: '已通过',
    symbol: 'PASS'
  },
  {
    id: '已驳回',
    name: '已驳回',
    symbol: 'REJECT'
  }
]);

const PAYSTATUS = new DictionaryBase('支付状态', [
  {
    id: 'UNPAID',
    name: '未支付',
    symbol: 'UNPAID'
  },
  {
    id: 'PAID',
    name: '已支付',
    symbol: 'PAID'
  },
  {
    id: 'REFUNDED',
    name: '已退款',
    symbol: 'REFUNDED'
  }
]);

const ORDERSTATUS = new DictionaryBase('订单状态', [
  {
    id: 'PENDING',
    name: '待处理',
    symbol: 'PENDING'
  },
  {
    id: 'PROCESSING',
    name: '处理中',
    symbol: 'PROCESSING'
  },
  {
    id: 'COMPLETED',
    name: '已完成',
    symbol: 'COMPLETED'
  },
  {
    id: 'CANCELLED',
    name: '已取消',
    symbol: 'CANCELLED'
  }
]);

const LiveCteateUserType = new DictionaryBase('直播创作者类型', [
  {
    id: 'VIDEO_DEPT',
    name: '视频部',
    symbol: 'VIDEO_DEPT'
  },
  {
    id: 'OUT_SOURCE',
    name: '外包',
    symbol: 'OUT_SOURCE'
  }
]);

const AddPosRsn = new DictionaryBase('职位增补缘由', [
  {
    id: 'ADDPOST',
    name: '新设岗位',
    symbol: 'ADDPOST'
  },
  {
    id: 'REPLACEPOST',
    name: '人员替换',
    symbol: 'REPLACEPOST'
  },
  {
    id: 'AUGMENT',
    name: '满能扩编',
    symbol: 'AUGMENT'
  },
  {
    id: 'OTHER',
    name: '其他',
    symbol: 'OTHER'
  }
]);

const StoreappPlatform = new DictionaryBase('应用支持渠道', [
  {
    id: 'CVTE3288',
    name: 'CVTE3288 商店应用',
    symbol: 'CVTE3288'
  },
  {
    id: 'HIKEEN2861',
    name: 'HIKEEN2861 商店应用',
    symbol: 'HIKEEN2861'
  },
  {
    id: 'HIKEEN3399',
    name: 'HIKEEN3399 商店应用',
    symbol: 'HIKEEN3399'
  },
  {
    id: 'CVTE3288_OTA',
    name: 'CVTE3288 OTA',
    symbol: 'CVTE3288_OTA'
  },
  {
    id: 'HIKEEN2861_OTA',
    name: 'HIKEEN2861 OTA',
    symbol: 'HIKEEN2861_OTA'
  },
  {
    id: 'HIKEEN3399_OTA',
    name: 'HIKEEN3399 OTA',
    symbol: 'HIKEEN3399_OTA'
  },
  {
    id: 'CVTE3288_SYS',
    name: 'CVTE3288   系统应用',
    symbol: 'CVTE3288_SYS'
  },
  {
    id: 'HIKEEN2861_SYS',
    name: 'HIKEEN2861  系统应用',
    symbol: 'HIKEEN2861_SYS'
  },
  {
    id: 'HIKEEN3399_SYS',
    name: 'HIKEEN3399  系统应用',
    symbol: 'HIKEEN3399_SYS'
  },
  {
    id: 'ANDROID_CLOUD',
    name: 'ANDROID手机WISSO云',
    symbol: 'ANDROID_CLOUD'
  },
  {
    id: 'IOS_CLOUD',
    name: 'IOS手机WISSO云',
    symbol: 'IOS_CLOUD'
  },
  {
    id: 'MAC_CLOUD',
    name: 'MACOS  WISSO云',
    symbol: 'MAC_CLOUD'
  },
  {
    id: 'WINDOWS_CLOUD',
    name: 'WINDOWS   PC  WISSO云',
    symbol: 'WINDOWS_CLOUD'
  }
]);

const StoreappMarket = new DictionaryBase('应用显示所在市场', [
  {
    id: 'WISSOCLOUD',
    name: 'WISSO云下载中心',
    symbol: 'WISSOCLOUD'
  },
  {
    id: 'BOARDSYS',
    name: 'WISSO系统应用',
    symbol: 'BOARDSYS'
  },
  {
    id: 'BOARDAPP',
    name: 'WISSO应用商店',
    symbol: 'BOARDAPP'
  }
]);

const PushRange = new DictionaryBase('应用推送范围', [
  {
    id: 'ALL',
    name: '全设备下发',
    symbol: 'ALL'
  },
  {
    id: 'POINT',
    name: '定点下发',
    symbol: 'POINT'
  },
  {
    id: 'POINTREVERSE',
    name: '反向定点下发',
    symbol: 'POINTREVERSE'
  }
]);

export {
  SysDataPermType,
  SysOperationType,
  SysPermModuleType,
  SysPermCodeType,
  SysMenuBindType,
  MobileEntryType,
  SysMenuType,
  ScatterSymbolType,
  SysCustomWidgetType,
  OnlineFormEventType,
  SysOnlineFormType,
  SysCustomWidgetOperationType,
  OnlineSystemVariableType,
  SysCustomWidgetBindDataType,
  SysMaskFieldType,
  EnumFileType,
  SysOnlineDictType,
  DirectionType,
  DblinkType,
  CriteriaFilterType,
  FormulaItemKind,
  SysOnlineRuleType,
  LogicOperatorType,
  CustomQueryFilterValueType,
  SysOnlineRelationType,
  SysAutoCodeType,
  SysUserStatus,
  SysUserType,
  ZODIACSIGN,
  STARSIGN,
  GENDER,
  PsscCertified,
  ExpertTimeCategory,
  PlatformType,
  DeptCategoryType,
  LiveControlType,
  ActivitiesCostType,
  WissoRoomStatus,
  MaritalStatus,
  ActivityDic,
  WORKSCORE,
  ApplyStatus,
  PAYSTATUS,
  ORDERSTATUS,
  LiveCteateUserType,
  AddPosRsn,
  StoreappPlatform,
  StoreappMarket,
  PushRange,
};
